import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import AButtonGridAdd from '@/components/atoms/AButtonGridAdd.vue'
	import AgDatatable from '@/components/datatable/AgDatatable.vue'
	import OptionalsCellRenderer from '@/components/datatable/cellRenderers/OptionalsCellRenderer.vue'
	import DeleteCellRenderer from '@/components/datatable/cellRenderers/DeleteCellRenderer.vue'
	import OptionalsCellEditor from '@/components/datatable/cellEditors/OptionalsCellEditor.vue'

	import type { ObjectContext } from '@/global'
	import { reactive, computed, watch, ComputedRef } from 'vue'
	import { useGeneral, useDatatable, useRole } from '@/hooks'

	
export default /*#__PURE__*/_defineComponent({
  props: {
		modelValue: { type: Array, default: () => [], required: true },
		tabSelected: { type: String, default: '', required: true },
		item: { type: Object, defaul: null, required: true },
		keysToAvoid: { type: Array, default: () => [] }
	},
  emits: ['update:modelValue', 'input', 'change', 'blur', 'clear', 'enter', 'deleteKey'],
  setup(__props, { emit: $emit }) {

const $props = __props

	
	

	const { $t, $store, tabSelected, icons } = useGeneral()
	const { suppressEnter } = useDatatable()
	const { EDIT_VISIBLE } = useRole(tabSelected.value)

	const state = reactive({
		items: []
	})

	watch(
		() => $props.modelValue,
		// @ts-ignore
		val => (state.items = val || [])
	)

	function addItem() {
		// @ts-ignore
		state.items.push({ key: '', value: null })
		onUpdateValue()
	}

	function deleteClick(idx: number) {
		const item: ObjectContext = state.items[idx]
		const key = item.key
		state.items.splice(idx, 1)
		onDeleteKey(key)
		onUpdateValue()
	}

	function onDeleteKey(key: string) {
		$emit('deleteKey', key)
	}

	function onUpdateValue() {
		$emit('update:modelValue', state.items)
	}

	function checkInput(event: string) {
		// Special Characters
		const startRegex = new RegExp(/^[^a-zA-Z_$]/)
		const regex = new RegExp(/^[^a-zA-Z_$]|[^0-9a-zA-Z_$]/)
		if (typeof event === 'string') {
			let startError = false
			const string = event.replace(/\s+/g, '_')
			const invalid: Array<string> = []
			for (let i = 0; i < string.length; i++) {
				const char = string[i]
				if (i === 0 && startRegex.test(char)) {
					invalid.push(char)
					startError = true
					break
				} else if (regex.test(char) && !invalid.includes(char)) invalid.push(char)
			}
			if (!invalid.length) return true
			else {
				const chars = invalid.join('&nbsp;')
				const text = startError ? 'cannotStartWith' : 'specialCharactersNotAllowed'
				// @ts-ignore
				$store.dispatch('alert/SET_ALERT', { text: $t(text, { chars: chars }) })
				return false
			}
		}
	}

	function valueSetter(params: ObjectContext) {
		const key = params.colDef.field
		if (params.newValue === undefined) return false
		else {
			const value = params.newValue !== params.oldValue ? params.newValue : params.oldValue
			const isValid = key === 'key' ? checkInput(value) : true
			if (!isValid) params.data[key] = params.oldValue
			else {
				params.data[key] = value
				if (key === 'key') {
					params.data['value'] = null
					onDeleteKey(params.oldValue)
				}
			}
			onUpdateValue()
			return isValid
		}
	}

	const keysToDisable: ComputedRef<Array<string>> = computed(() => state.items.map((e: ObjectContext) => e.key))

	// @ts-ignore
	const headers: Array<ObjectContext> = computed(() => {
		// @ts-ignore
		const headers = [
			{
				headerName: 'General_variable',
				field: 'key',
				sortable: false,
				resizable: false,
				suppressMovable: true,
				editable: EDIT_VISIBLE.value,
				cellRenderer: OptionalsCellRenderer,
				cellEditor: OptionalsCellEditor,
				cellEditorParams: {
					tabSelected: $props.tabSelected,
					keysToAvoid: $props.keysToAvoid,
					keysToDisable: keysToDisable.value
				},
				valueSetter: (params: ObjectContext) => valueSetter(params)
			},
			{
				headerName: 'General_value',
				field: 'value',
				sortable: false,
				resizable: false,
				suppressMovable: true,
				editable: EDIT_VISIBLE.value,
				cellRenderer: OptionalsCellRenderer,
				cellEditor: OptionalsCellEditor,
				cellRendererParams: {
					mainItem: $props.item
				},
				cellEditorParams: {
					tabSelected: $props.tabSelected
				},
				valueSetter: (params: ObjectContext) => valueSetter(params)
			}
		]
		if (EDIT_VISIBLE.value) {
			headers.push({
				headerName: 'Action_delete',
				field: 'actions',
				// @ts-ignore
				width: 100,
				pinned: 'left',
				sortable: false,
				resizable: false,
				suppressMovable: true,
				// @ts-ignore
				cellRenderer: DeleteCellRenderer,
				cellRendererParams: {
					// @ts-ignore
					deleteClick: deleteClick.bind(this)
				},
				suppressKeyboardEvent: (params: ObjectContext) => suppressEnter(params)
			})
		}
		return headers
	})

return (_ctx: any,_cache: any) => {
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_expand_transition, null, {
      default: _withCtx(() => [
        (_unref(state).items.length)
          ? (_openBlock(), _createBlock(AgDatatable, {
              key: 0,
              headers: _unref(headers),
              items: _unref(state).items,
              "auto-height": ""
            }, null, 8, ["headers", "items"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(AButtonGridAdd, {
      element: "Form_step_optional",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (addItem()))
    })
  ], 64))
}
}

})